import Vue from "vue";
import VueRouter from "vue-router";
import pinia from "../pinia";
import { useFilterStore } from "../store/useFilterStore";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    redirect: "/societyadmin/login",
  },

  {
    path: "/societyadmin/login",
    name: "societyadminLogin",
    component: () => import("../components/societyadmin/auth/Login"),
  },
  {
    path: "/societyadmin/verifyOtp/:mobileNo",
    name: "societyadminVerifyOtp",
    component: () => import("../components/societyadmin/auth/VerifyOtp"),
  },
  {
    path: "/societyadmin/login",
    name: "logout",
    component: () => import("../components/societyadmin/auth/Login"),
  },
  {
    path: "/societyadmin/",
    name: "societyadminHome",
    component: () => import("../components/societyadmin/layouts/layout"),
    children: [
      {
        path: "profile",
        name: "societyadminProfile",
        component: () => import("../components/societyadmin/Profile"),
      },

      {
        path: "permissions",
        name: "societyadminPermissions",
        component: () =>
          import("../components/societyadmin/permissions/Permissions"),
      },
      {
        path: "plan",
        name: "societyadminPermissions",
        component: () =>
          import("../components/societyadmin/MyPlan"),
      },
      {
        path: "member/requests",
        name: "societyadminHouseRequest",
        component: () =>
          import("../components/societyadmin/house/MemberRequest"),
      },
      {
        path: "member/list",
        name: "societyadminHouse",
        component: () => import("../components/societyadmin/house/Member"),
      },
      {
        path: "member/add",
        name: "societyadminHouseAdd",
        component: () => import("../components/societyadmin/house/AddMember"),
      },
      {
        path: "member/edit/:id",
        name: "societyadminHouseEdit",
        component: () => import("../components/societyadmin/house/EditMember"),
      },
      {
        path: "member/view/:id",
        name: "societyadminHouseView",
        component: () => import("../components/societyadmin/house/ViewMember"),
      },
      {
        path: "block",
        name: "societyadminFlat",
        component: () => import("../components/societyadmin/block/Flat"),
      },
      {
        path: "responsibleperson",
        name: "societyadminResponsiblePerson",
        component: () =>
          import(
            "../components/societyadmin/responsibleperson/ResponsiblePerson"
          ),
      },
      {
        path: "responsibleperson/add",
        name: "societyadminResponsiblePersonAdd",
        component: () =>
          import(
            "../components/societyadmin/responsibleperson/AddResponsiblePerson"
          ),
      },
      {
        path: "responsibleperson/edit/:id",
        name: "societyadminResponsiblePersonEdit",
        component: () =>
          import(
            "../components/societyadmin/responsibleperson/EditResponsiblePerson"
          ),
      },
      {
        path: "event",
        name: "societyadminEvent",
        component: () => import("../components/societyadmin/event/Event"),
      },
      {
        path: "event/view/:id",
        name: "societyadminEventView",
        component: () => import("../components/societyadmin/event/ViewEvent"),
      },
      {
        path: "event/add",
        name: "societyadminEventAdd",
        component: () => import("../components/societyadmin/event/AddEvent"),
      },
      {
        path: "event/edit/:id",
        name: "societyadminEventEdit",
        component: () => import("../components/societyadmin/event/EditEvent"),
      },
      {
        path: "announcement",
        name: "societyadminAnnouncement",
        component: () => import("../components/societyadmin/announcement/list"),
      },
      {
        path: "committemember",
        name: "committemember",
        component: () =>
          import("../components/societyadmin/committemember/Committemember"),
      },

      {
        path: "theme",
        name: "societyadminTheme",
        component: () => import("../components/societyadmin/Theme"),
      },
      {
        path: "notice",
        name: "societyadminNotice",
        component: () => import("../components/societyadmin/notice/Notice"),
      },
      {
        path: "notice/view/:id",
        name: "societyadminNoticeView",
        component: () => import("../components/societyadmin/notice/ViewNotice"),
      },
      {
        path: "notice/add",
        name: "societyadminNoticeAdd",
        component: () => import("../components/societyadmin/notice/AddNotice"),
      },
      {
        path: "notice/edit/:id",
        name: "societyadminNoticeEdit",
        component: () => import("../components/societyadmin/notice/EditNotice"),
      },
      {
        path: "staff",
        name: "societyadminStaff",
        component: () => import("../components/societyadmin/staff/Staff"),
      },

      {
        path: "complaints",
        name: "Complaints",
        component: () =>
          import("../components/societyadmin/complaints/Complaints"),
      },
      {
        path: "complaints/view/:id",
        name: "ComplaintsView",
        component: () =>
          import("../components/societyadmin/complaints/ViewComplaints"),
      },
      {
        path: "expense",
        name: "societyadminExpense",
        component: () => import("../components/societyadmin/expense/Expense"),
      },
      {
        path: "expense/view/:id",
        name: "societyadminExpenseView",
        component: () =>
          import("../components/societyadmin/expense/ViewExpense"),
      },
      {
        path: "expense/add",
        name: "societyadminExpenseAdd",
        component: () =>
          import("../components/societyadmin/expense/AddExpense"),
      },
      {
        path: "expense/edit/:id",
        name: "societyadminExpenseEdit",
        component: () =>
          import("../components/societyadmin/expense/EditExpense"),
      },
      {
        path: "gallery",
        name: "societyadminGallery",
        component: () => import("../components/societyadmin/gallery/Gallery"),
      },
      {
        path: "gallery/view/:id",
        name: "societyadminGalleryView",
        component: () =>
          import("../components/societyadmin/gallery/ViewGallery"),
      },
      {
        path: "gallery/add",
        name: "societyadminGalleryAdd",
        component: () =>
          import("../components/societyadmin/gallery/AddGallery"),
      },
      {
        path: "gallery/edit/:id",
        name: "societyadminGalleryEdit",
        component: () =>
          import("../components/societyadmin/gallery/EditGallery"),
      },
      {
        path: "category",
        name: "societyadminExpenseCategory",
        component: () => import("../components/societyadmin/category/List"),
      },
      {
        path: "securityguard",
        name: "societyadminSecurityguard",
        component: () =>
          import("../components/societyadmin/securityguard/List"),
      },
      {
        path: "bills",
        name: "societyadminBills",
        component: () => import("../components/societyadmin/bills/BillList"),
      },
      {
        path: "bills/add",
        name: "societyadminBillsAdd",
        component: () => import("../components/societyadmin/bills/AddBill"),
      },
      {
        path: "bills/view/:id",
        name: "societyadminBillsView",
        component: () => import("../components/societyadmin/bills/ViewBill"),
      },
      {
        path: "bills/edit/:id",
        name: "societyadminBillsEdit",
        component: () => import("../components/societyadmin/bills/EditBill"),
      },
      {
        path: "dashboard",
        name: "societyadminDashboard",
        component: () => import("../components/societyadmin/Dashboard"),
      },
      {
        path: "bills/house",
        name: "societyadminBillHouse",
        component: () =>
          import("../components/societyadmin/bills/BillHouseList"),
      },
      {
        path: "visitor",
        name: "SocietyAdminVisitor",
        component: () => import("../components/societyadmin/visitor/List"),
      },
      {
        path: "chat",
        name: "SocietyAdminChat",
        component: () => import("../components/societyadmin/chat/Chat.vue"),
      },
    ],
  },
  {
    path: "/societyadmin/404",
    name: "societyadmin404",
    component: () => import("../components/societyadmin/404"),
  },
  {
    path: "*",
    name: "notfound",
    component: () => import("../components/404"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  // --- Filter Module Tracking ---
  const pathParts = to.path.split("/").filter(p => p);
  const adminIdx = pathParts.indexOf("societyadmin");
  if (adminIdx !== -1 && pathParts[adminIdx + 1]) {
    const moduleName = pathParts[adminIdx + 1];
    // List of "module" names that should trigger a filter reset if changed
    // We only care about the top-level module (member, event, notice, etc.)
    const filterStore = useFilterStore(pinia);
    filterStore.handleModuleChange(moduleName);
  }

  const isPlanExpired = localStorage.getItem("isPlanExpired") === "true";
  const allowedRoutesWhenExpired = [
    "societyadminDashboard",
    "societyadminLogin",
    "societyadminVerifyOtp",
    "logout",
    "societyadminProfile"
  ];

  // If plan is expired and trying to access a restricted societyadmin route
  if (
    isPlanExpired &&
    to.path.startsWith("/societyadmin") &&
    !allowedRoutesWhenExpired.includes(to.name) &&
    !to.path.includes("/plan") // Allow plan renewal page
  ) {
    next({ path: "/societyadmin/dashboard" });
    return;
  }

  let isAuthenticated = false;
  let role;
  let user = localStorage.getItem("user");

  if (user) {
    isAuthenticated = true;
    user = JSON.parse(user);
    role = user.role;
  }

  const publicRoutes = ["Home", "Features", "Pricing", "About", "Contact", "Privacy", "Terms"];
  if (publicRoutes.includes(to.name)) {
    next();
    return;
  }

  const NonAuthRoutesForSuperAdmin = [
    "superadminLogin",
    "superadminForgotPassword",
    "superadminResetPassword",
  ];
  const NonAuthRoutesForSocietyAdmin = [
    "societyadminLogin",
    "societyadminVerifyOtp",
  ];

  const CmsRoute = [
    "superadminPrivacy",
    "superadminTerm"
  ]
  if (CmsRoute.includes(to.name)) {
    next();
    return;
  }
  if (NonAuthRoutesForSuperAdmin.includes(to.name) && !isAuthenticated) {
    next();
    return;
  } else if (NonAuthRoutesForSocietyAdmin.includes(to.name) && !isAuthenticated) {
    next();
    return;
  }

  if (
    !NonAuthRoutesForSuperAdmin.includes(to.name) &&
    !isAuthenticated &&
    to?.path?.startsWith("/superadmin")
  ) {
    next({ path: "/superadmin/login" });
    return;
  } else if (
    !NonAuthRoutesForSocietyAdmin.includes(to.name) &&
    !isAuthenticated &&
    to?.path?.startsWith("/societyadmin")
  ) {
    next({ path: "/societyadmin/login" });
    return;
  }

  if (
    NonAuthRoutesForSuperAdmin.includes(to.name) &&
    isAuthenticated &&
    role == "superadmin"
  ) {
    next({ path: "/superadmin/dashboard" });
    return;
  } else if (
    NonAuthRoutesForSocietyAdmin.includes(to.name) &&
    isAuthenticated &&
    role == "societyadmin"
  ) {
    next({ path: "/societyadmin/dashboard" });
    return;
  }

  if (
    role == "superadmin" &&
    isAuthenticated &&
    to.path.startsWith("/superadmin/")
  ) {
    next();
    return;
  } else if (
    role == "societyadmin" &&
    isAuthenticated &&
    to.path.startsWith("/societyadmin/")
  ) {
    next();
    return;
  } else {
    // console.log(role);
    console.error("Route not found");
    if (role) {
      next({ path: "/" + role + "/dashboard" });
    } else {
      next({ path: "/" });
    }
  }
});

export default router;
